/**
 * Defines the type of a connection point.
 */
export var ConnectionPointType;
(function (ConnectionPointType) {
    /** Float */
    ConnectionPointType[ConnectionPointType["Float"] = 1] = "Float";
    /** Texture */
    ConnectionPointType[ConnectionPointType["Texture"] = 2] = "Texture";
    /** Color3 */
    ConnectionPointType[ConnectionPointType["Color3"] = 3] = "Color3";
    /** Color4 */
    ConnectionPointType[ConnectionPointType["Color4"] = 4] = "Color4";
    /** Boolean */
    ConnectionPointType[ConnectionPointType["Boolean"] = 5] = "Boolean";
    /** Vector2 */
    ConnectionPointType[ConnectionPointType["Vector2"] = 6] = "Vector2";
})(ConnectionPointType || (ConnectionPointType = {}));
//# sourceMappingURL=connectionPointType.js.map